import React from 'react';
import { Spinner } from '@/components/ui/spinner';

export const ScreenSpinner = () => {
  return (
    <div className="flex justify-center items-center h-screen bg-white dark:bg-gray-900">
      <Spinner size="xl" />
    </div>
  );
};
